import request from '@/utils/requestHome'

export function creditTop (data) {
  return request({
    url: '/credit/top',
    method: 'post',
    data
  })
}
export function problemAdd (data) {
  return request({
    url: '/problem/add',
    method: 'post',
    data
  })
}

export function home (data) {
  return request({
    url: '/home',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js